module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"connectToGoogle":{"stages":{"connect":"Connect","setAvailabilityInfo":"Info","setAvailabilityHours":"Availability","options":"Options","automate":"Automate"}},"modalTitle":"Create a booking link"}}')
  delete Component.options._Ctor
}
